import { JsonView, defaultStyles } from 'react-json-view-lite';

export function Json({ data }: { data: unknown }) {
  if (data === null || data === undefined) {
    return <p className="text-xs text-muted-foreground">—</p>;
  }
  return (
    <div className="text-xs">
      <JsonView
        data={data as object}
        shouldExpandNode={(level) => level < 1}
        style={defaultStyles}
      />
    </div>
  );
}
